<script setup lang="ts">
import { afaireFocusHref, consequenceLine, type ActionConsequence } from '@cockpit/shared';

/**
 * Lot T : bloc « Conséquences » des résultats d'un plan (écran de validation, fenêtre mail) : les cartes de
 * « À faire » ajoutées ou fermées par les règles juste après l'exécution, chacune avec un lien vers
 * « À faire » centré sur elle.
 */
defineProps<{ consequences: readonly ActionConsequence[]; meId: string | null }>();
const emit = defineEmits<{ navigate: [] }>();
</script>

<template>
  <section v-if="consequences.length > 0" class="consequences" data-testid="plan-consequences">
    <h3>Conséquences</h3>
    <ul>
      <li v-for="c in consequences" :key="`${c.kind}-${c.actionId}`" :data-kind="c.kind">
        <div>
          <b>{{ consequenceLine(c, meId) }}</b>
          <small>{{ c.reason }}</small>
        </div>
        <RouterLink class="btn sm" :to="afaireFocusHref([c.actionId])" @click="emit('navigate')"
          >Voir</RouterLink
        >
      </li>
    </ul>
  </section>
</template>

<style scoped>
.consequences {
  margin-top: 12px;
  border-top: 1px solid var(--line);
  padding-top: 10px;
}
.consequences h3 {
  margin: 0 0 6px;
  font-size: 13px;
}
.consequences ul {
  list-style: none;
  margin: 0;
  padding: 0;
  display: grid;
  gap: 6px;
}
.consequences li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 13px;
}
.consequences li div {
  display: grid;
  min-width: 0;
}
.consequences small {
  color: var(--muted);
  font-size: 12px;
}
</style>
